// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"446":"e0554c24","484":"0c9cf457"}[chunkId] + ".chunk.css";
};